// Module
var code = `<div class="cp-chart"> <canvas></canvas> </div> `;
// Exports
module.exports = code;